import WalasFormModal from "./WalasFormModal";

export default function UpdateWalas(props) {
  return <WalasFormModal {...props} mode="update" />;
}
